'use strict';

define('strHelper',[], function () {
        
    // IE doesn't support endsWith.  So, let's add it to the String prototype in this window
    var endsWith = function (input, searchString) {
            return input.indexOf(searchString, input.length - searchString.length) !== -1;
    };
          
    return {
        endsWith: endsWith
    };
});
